<template>
  <div id="shopCategory"
    :class="{isStore: isStore}"
    :style="baseStyle">
    <div v-if="!isStore" class="categoryGroup" :data-depth="1">
      <ul class="categoryList">
        <li
          v-for="(item, index) in categoryList"
          :key="index"
          class="categoryItem"
          :id="`category_${item.categoryId}`"
          :class="{active: activeCategoryIds.includes(item.categoryId)}"
          :style="activeCategoryIds.includes(item.categoryId) && { ...setStyle('productActivate', 'border-color'), ...setStyle('productActivate', 'color'), ...setStyle('productActivate', 'background-color', 10) }"
          @click.stop="clickCategory(item.categoryId)">
          {{ item.categoryLabel[lang] }}
        </li>
      </ul>
    </div>
    <div v-if="depth2Category" class="categoryGroup" :data-depth="2">
      <ul class="categoryList">
        <li
          v-for="(item, index) in depth2Category"
          :key="index"
          class="categoryItem"
          :id="`category_${item.categoryId}`"
          :class="{active: activeCategoryIds.includes(item.categoryId)}"
          :style="activeCategoryIds.includes(item.categoryId) && { ...setStyle('productActivate', 'border-color'), ...setStyle('productActivate', 'color') }"
          @click.stop="clickCategory(item.categoryId)">
          {{ item.categoryLabel[lang] }}
        </li>
      </ul>
    </div>
    <div v-if="depth3Category" class="categoryGroup" :data-depth="3">
      <ul class="categoryList">
        <li
          v-for="(item, index) in depth3Category"
          :key="index"
          class="categoryItem"
          :id="`category_${item.categoryId}`"
          :class="{active: activeCategoryIds.includes(item.categoryId)}"
          @click.stop="clickCategory(item.categoryId)">
          {{ item.categoryLabel[lang] }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopCategory',
  props: [
    'locale',
    'lang',
    'responsive',
    'shopPageId',
    'category',
    'isDetail',
    'isCart'
  ],
  computed: {
    baseStyle () {
      const baseColors = this.$store.getters['common/getPointColorsMultiple']
      const baseBg = baseColors([{ target: 'contentsBg', attr: 'background-color' }])
      const baseText = baseColors([{ target: 'contentsText', attr: 'color' }])
      return {
        ...baseBg,
        ...baseText,
        top: this.positionTop
      }
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    categoryId () {
      return this.$route.params && this.$route.params.shopCategoryId
    },
    isStore () { // 상품페이지의 1뎁스카테고리를 내비게이션으로 사용
      return this.$route.name === 'store' && this.responsive === 'tablet'
    },
    // 스토어에서 현재 페이지용 원본 카테고리 나무 가져오기
    rawCategoryList () {
      const getter = this.$store.getters['shop/getCategoryNav']
      return getter ? (getter(this.shopPageId) || []) : []
    },

    // 숨김 그룹 반영한 최종 카테고리 리스트(트리)
    categoryList () {
      return this.filterVisibleCategories(this.rawCategoryList, this.hiddenGroupIds)
    },
    depth2Category () {
      const hiddenGroupIds = this.hiddenGroupIds
      const categoryId = this.activeCategoryIds[0]
      const category1 = categoryId && this.categoryList.find(x => x.categoryId === categoryId)
      return category1 && category1.subCategory
    },
    depth3Category () {
      const hiddenGroupIds = this.hiddenGroupIds
      const categoryId = this.activeCategoryIds[1]
      const category2 = categoryId && this.depth2Category && this.depth2Category.find(x => x.categoryId === categoryId)
      return category2 && category2.subCategory
    },
    stopScrollEvent () {
      const isDetail = this.isDetail !== null && typeof (this.isDetail) !== 'undefined'
      const isCart = !this.isStore && this.isCart
      return isDetail || isCart
    },
    hiddenGroupIds () {
      return this.$store.getters['shop/getHiddenGroup']
    }
  },
  created () {
    // 라우팅 보정
    this._debouncedReroute = _.debounce((firstVisible) => {
      this.$router.replace({ params: { shopCategoryId: firstVisible } })
    }, 150)
  },
  mounted () {
    this.$nextTick(() => {
      this.isAutoScrolling = true
      this.setTopPosition()
      // 라우트 파라미터가 없을 때 첫 보이는 카테고리로 이동
      if (!this.categoryId && this.categoryList.length) {
        const firstVisible = this.getDeepestFirstCategoryId(this.categoryList, this.categoryList[0].categoryId)
        if (firstVisible) this.$router.replace({ params: { shopCategoryId: firstVisible } })
      }
      if (this.categoryId) {
        this.scrollToList(this.categoryId)
      }
      // this.activateCategory((this.categoryId) || (this.categoryList[0] && this.categoryList[0].categoryId), true)
      const nav = document.querySelector('#nav')
      if (nav) {
        nav.addEventListener('click', this.handleClickNav, { passive: true })
        nav.addEventListener('scroll', this.handleScrollNav, { passive: true })
      }
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('wheel', this.onUserScroll)
      window.addEventListener('touchstart', this.onTouchStart)
      window.addEventListener('touchmove', this.onTouchMove)
      window.addEventListener('resize', this.setTopPosition)
    })
  },
  beforeDestroy () {
    this._debouncedReroute && this._debouncedReroute.cancel && this._debouncedReroute.cancel()
    const nav = document.querySelector('#nav')
    if (nav) {
      nav.removeEventListener('click', this.handleClickNav)
      nav.removeEventListener('scroll', this.handleScrollNav)
    }
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('wheel', this.onUserScroll)
    window.removeEventListener('touchstart', this.onTouchStart)
    window.removeEventListener('touchmove', this.onTouchMove)
    window.removeEventListener('resize', this.setTopPosition)
  },
  watch: {
    categoryId: {
      handler (categoryId) {
        this.activateCategory(categoryId, this.isAutoScrolling)
      },
      immediate: true
    },
    categoryList: {
      immediate: true,
      deep: true,
      handler (list) {
        if (!list || !list.length) return

        const currentId = this.categoryId
        const exists = this._existsInList(list, currentId)
        const firstVisible = this.getDeepestFirstCategoryId(list, list[0].categoryId)

        // 현재 카테고리가 사라졌으면(숨김·트리 변경) 첫 보이는 카테고리로 이동
        if (!exists && firstVisible) {
          (typeof this._debouncedReroute === 'function')
            ? this._debouncedReroute(firstVisible)
            : this.$router.replace({ params: { shopCategoryId: firstVisible } })
        }

        // 활성화 갱신 (현재 id가 없으면 첫 보이는 카테고리 기준)
        this.activateCategory(currentId || firstVisible, this.isAutoScrolling)
      }
    },
    stopScrollEvent (isStopScroll) {
      if (isStopScroll) {
        const nav = document.querySelector('#nav')
        if (nav) {
          nav.removeEventListener('click', this.handleClickNav)
          nav.removeEventListener('scroll', this.handleScrollNav)
        }
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('wheel', this.onUserScroll)
        window.removeEventListener('touchstart', this.onTouchStart)
        window.removeEventListener('touchmove', this.onTouchMove)
      } else {
        setTimeout(() => {
          const nav = document.querySelector('#nav')
          if (nav) {
            nav.addEventListener('click', this.handleClickNav, { passive: true })
            nav.addEventListener('scroll', this.handleScrollNav, { passive: true })
          }
          window.addEventListener('scroll', this.handleScroll)
          window.addEventListener('wheel', this.onUserScroll)
          window.addEventListener('touchstart', this.onTouchStart)
          window.addEventListener('touchmove', this.onTouchMove)
        }, 100)
      }
    }
  },
  data () {
    const noop = Object.assign(() => {}, { cancel: () => {} })
    return {
      isAutoScrolling: true, // 페이지 이동 또는 카테고리 클릭으로 이동했을 때는 categoryId를 이벤트리스너에서 감지할 필요가 없음
      positionTop: '0',
      touchStartY: 0,
      touchMoved: false,
      activeCategoryIds: [], // 활성화된 카테고리 ID들의 배열
      _debouncedReroute: noop
    }
  },
  methods: {
    _existsInList (list, id) {
      if (!id) return false
      const stack = [...list]
      while (stack.length) {
        const n = stack.pop()
        if (n.categoryId === id) return true
        if (n.subCategory) stack.push(...n.subCategory)
      }
      return false
    },
    onUserScroll () {
      // 유저가 직접 스크롤 하고 있음(wheel, touch)
      this.isAutoScrolling = false
    },
    onTouchStart(event) {
      this.touchStartY = event.touches[0].clientY
      this.touchMoved = false
    },
    onTouchMove(event) {
      const currentY = event.touches[0].clientY
      if (Math.abs(currentY - this.touchStartY) > 5) { // 터치 임계점 5px
        this.touchMoved = true
        this.isAutoScrolling = false
      }
    },
    getDeepestFirstCategoryId (categoryList, targetId) {
      // 1depth에서 해당 categoryId를 찾음
      const root = categoryList.find(cat => cat.categoryId === targetId)
      if (!root) return null

      let current = root
      // subCategory의 0번째를 따라 내려감
      while (current.subCategory && current.subCategory.length > 0) {
        current = current.subCategory[0]
      }
      return current.categoryId || null
    },
    setTopPosition () {
      const header = document.getElementById('header')
      const isTablet = this.responsive === 'tablet'
      if (header) {
        const height = header.clientHeight
        const newPosition = isTablet ? '0' : `${height}px`
        if (this.positionTop !== newPosition) { // 값이 다를 때만 변경
          this.positionTop = newPosition
        }
      }
    },
    handleClickNav () {
      this.clickCategory(this.categoryId)
    },
    handleScrollNav () {
      this.isAutoScrolling = false
    },
    handleScroll () {
      if (this.isAutoScrolling) return

      const scrollY = window.scrollY
      const windowHeight = window.innerHeight
      const categoryElement = document.getElementById('shopCategory')
      if (!categoryElement) return

      const categoryRect = categoryElement.getBoundingClientRect()
      // const categoryLine = categoryRect.bottom // = top + height
      const categoryLine = 60

      const itemGroups = document.querySelectorAll('.shopItemGroup:not(.isHiddenGroup)')
      if (!itemGroups.length) return

      let targetCategoryId = null

      const first = itemGroups[0]
      const last = itemGroups[itemGroups.length - 1]
      const firstRect = first.getBoundingClientRect()
      const lastRect = last.getBoundingClientRect()

      // 1) 최상단 판정: 거의 맨 위일 때는 무조건 첫 그룹
      const nearTop = scrollY <= 0 || firstRect.top >= categoryLine - 1

      // 2) 최하단 판정: "마지막 그룹의 바닥이 화면 하단 근처"일 때
      const nearBottom = lastRect.bottom <= windowHeight + 1

      if (nearTop) {
        targetCategoryId = first.id
      } else if (nearBottom) {
        targetCategoryId = last.id
      } else {
        // 3) 중간 구간: categoryLine 을 가로지르는 그룹 중 (가장 아래쪽인) 하나
        itemGroups.forEach((item) => {
          const rect = item.getBoundingClientRect()

          // 화면 완전히 밖이면 무시 (성능/안정성)
          if (rect.bottom < 0 || rect.top > windowHeight) return

          // 이 그룹이 카테고리 라인을 "포함"하는지?
          const crossesLine = rect.top <= categoryLine && rect.bottom >= categoryLine

          if (crossesLine) {
            // 루프 순서대로라면 "아래쪽에 있는 것"이 마지막에 남음
            targetCategoryId = item.id
          }
        })
      }

      const ids = this.activeCategoryIds
      const currentActiveId = Array.isArray(ids) && ids.length ? ids[ids.length - 1] : null
      if (targetCategoryId && targetCategoryId !== currentActiveId) {
        this.activateCategory(targetCategoryId, false)
      }
    },
    clickCategory (categoryId) {
      this.isAutoScrolling = true
      this.activateCategory(categoryId, true)
    },
    activateCategory (categoryId, shouldScroll = true) {
      if (!categoryId) return
      function findCategoryPath(categoryList, id, parentPath = []) {
        for (const category of categoryList) {
          const currentPath = [...parentPath, category.categoryId]
          if (category.categoryId === id) {
            return {
              path: currentPath,
              subCategory: category.subCategory || null
            }
          }
          if (category.subCategory) {
            const result = findCategoryPath(category.subCategory, id, currentPath)
            if (result) return result
          }
        }
        return null
      }
      const ids = findCategoryPath(this.categoryList, categoryId)
      if (ids && ids.path) {
        this.activeCategoryIds = ids.path
        if (ids.subCategory) {
          this.activeCategoryIds.push(ids.subCategory[0].categoryId)
        }

        this.scrollCategories()
        const last = ids.path[ids.path.length - 1] // 배열 마지막
        this.$router.push({
          params: { shopCategoryId: last }
        })

        // 스크롤 이동은 명시적으로 허용될 때만
        if (shouldScroll) {
          this.scrollToList(categoryId)
        }
      }
    },
    scrollCategories () { // 카테고리 가로스크롤 중앙으로 이동
      this.$nextTick(() =>{
        const activeCategoryIds = this.activeCategoryIds
        activeCategoryIds.forEach(function (id) {
          const categoryElement = document.getElementById(`category_${id}`)
          if (categoryElement) {
            categoryElement.scrollIntoView({
              block: 'nearest',
              inline: 'center'
            })
          }
        })
      })
    },
    scrollToList(categoryId) {
      const groupElement = document.getElementById(categoryId)
      if (groupElement) {
        const stickyElement = document.getElementById('shopCategory')
        const stickyTop = stickyElement ? stickyElement.getBoundingClientRect().top : 0
        const stickyHeight = stickyElement ? stickyElement.offsetHeight : 0
        const elementTop = groupElement.getBoundingClientRect().top + window.scrollY
        const targetScrollY = elementTop - stickyTop - stickyHeight

        this.isAutoScrolling = true

        window.scrollTo({
          top: targetScrollY,
          left: 0,
          // behavior: 'smooth'
        })
        // 스크롤 위치 비교하여 scrolling 끝났는지 확인
        let lastY = window.scrollY
        let stableCount = 0
        const checkIfScrollEnded = () => {
          const currentY = window.scrollY
          if (Math.abs(currentY - lastY) < 2) {
            stableCount++
          } else {
            stableCount = 0
            lastY = currentY
          }

          if (stableCount > 3) {
            // 스크롤이 멈췄다고 판단
            this.isAutoScrolling = false
          } else {
            requestAnimationFrame(checkIfScrollEnded)
          }
        }
        requestAnimationFrame(checkIfScrollEnded)
      }
    },
    setStyle (target, attr, alpha) {
      return this.pointColors(target, attr, alpha)
    },
    filterVisibleCategories (category, hiddenGroupIds) {
      function traverse(node) {
        let filteredSub = []
        if (node.subCategory && node.subCategory.length > 0) {
          filteredSub = node.subCategory
            .map(traverse)
            .filter(Boolean)
        }
        const isSelfHidden = hiddenGroupIds.includes(node.categoryId)
        if (isSelfHidden || (node.subCategory && node.subCategory.length && filteredSub.length === 0)) return null

        return {
          categoryId: node.categoryId,
          categoryLabel: node.categoryLabel,
          ...(filteredSub.length > 0 && { subCategory: filteredSub })
        }
      }
      return category.map(traverse).filter(Boolean)
    }
  }
}
</script>
